__turbopack_context__.v({
  "buttons-container": "dqpAccountClosure-module-scss-module__iPeUTW__buttons-container",
  "content": "dqpAccountClosure-module-scss-module__iPeUTW__content",
  "status": "dqpAccountClosure-module-scss-module__iPeUTW__status",
});
